<mat-card>
  <app-card-header
    [title]="'Visualizador de Control Horario'"
    icono="schedule"
    [botonCerrar]="true"
    (cerrar)="dialogRef.close()"
  ></app-card-header>

  <!-- Content -->
  <mat-card-content class="card-content-crear">
    <div class="calendario-semanal">
      <!-- Encabezado con horas -->
      <div class="fila-horas">
        <div class="columna-dia"></div>
        <div class="columna-timeline-header">
          @for (hora of horas; track hora) {
            <div class="etiqueta-hora-top" [style.left.%]="(hora / 24) * 100">
              {{ hora.toString().padStart(2, '0') }}:00
            </div>
          }
        </div>
      </div>

      <!-- Filas por día -->
      @for (dia of diasSemana; track dia) {
        <div class="fila-dia" [class.sin-horarios]="!tieneHorarios(dia)">
          <div class="columna-dia">
            <span class="nombre-dia">{{ getNombreDiaConTilde(dia) }}</span>
          </div>
          <div class="columna-timeline">
            <!-- Línea base del día -->
            <div class="linea-base"></div>

            <!-- Línea central (12:00) -->
            <div class="linea-central"></div>

            <!-- Marcas de 15 minutos (más pequeñas) -->
            @for (cuarto of cuartosHora; track cuarto) {
              <div
                class="marca-cuarto"
                [style.left.%]="(cuarto / 24) * 100"
              ></div>
            }

            <!-- Marcas de media hora (medianas) -->
            @for (media of mediasHoras; track media) {
              <div
                class="marca-media"
                [style.left.%]="(media / 24) * 100"
              ></div>
            }

            <!-- Marcas de horas (más grandes) -->
            @for (hora of horas; track hora) {
              <div class="marca-hora" [style.left.%]="(hora / 24) * 100"></div>
            }

            <!-- Segmentos de horario -->
            @if (tieneHorarios(dia)) {
              @for (segmento of getSegmentosPorDia(dia); track $index) {
                <div
                  class="segmento"
                  [class.apertura]="segmento.tipo === 'apertura'"
                  [class.cierre]="segmento.tipo === 'cierre'"
                  [style.left.%]="calcularPosicion(segmento.inicio)"
                  [style.width.%]="calcularAncho(segmento.inicio, segmento.fin)"
                  [style.background]="
                    segmento.tipo === 'apertura'
                      ? 'linear-gradient(to right, rgba(143, 244, 188, 0.6) 0%, rgba(143, 244, 188, 0.6) ' +
                        calcularPosicionOrigen(segmento) +
                        '%, rgba(0, 230, 118, 0.8) ' +
                        calcularPosicionOrigen(segmento) +
                        '%, rgba(0, 230, 118, 0.8) 100%)'
                      : 'linear-gradient(to right, rgba(255, 153, 153, 0.6) 0%, rgba(255, 153, 153, 0.6) ' +
                        calcularPosicionOrigen(segmento) +
                        '%, rgba(238, 90, 82, 0.8) ' +
                        calcularPosicionOrigen(segmento) +
                        '%, rgba(238, 90, 82, 0.8) 100%)'
                  "
                  [tooltip]="
                    (segmento.tipo === 'apertura' ? 'Apertura: ' : 'Cierre: ') +
                    formatearHora(segmento.horaInicial) +
                    ' (-' +
                    segmento.toleranciaAntes +
                    ' / +' +
                    segmento.toleranciaDespues +
                    ' min)'
                  "
                >
                  <span class="etiqueta-hora-central">
                    {{ formatearHora(segmento.horaInicial) }}
                  </span>
                  <div
                    class="marca-origen"
                    [style.left.%]="calcularPosicionOrigen(segmento)"
                  ></div>
                </div>
              }
            } @else {
              <div class="sin-configuracion">Sin configuración</div>
            }
          </div>
        </div>
      }
    </div>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="dialogRef.close()">
      Cerrar
    </button>
  </mat-card-actions>
</mat-card>
